import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { CreateDataPolicy } from 'containers/Jit/MaskingPolicies/Components/DataPolicyWizard/CreateDataPolicy';
import { actions } from 'containers/Jit/MaskingPolicies/slice';

export const EditDataPolicy = () => {
  const dispatch = useDispatch();
  const params = useParams<{ id: string }>();

  useEffect(() => {
    if (!params.id) return;
    dispatch(actions.getMultiBlockPolicy({ q: { policyId: params.id } }));
  }, [params.id, dispatch]);

  return <CreateDataPolicy action="Update" />;
};
